import { $AllSelectableTypes } from "./TypeSwitcher.types";

export const ALL_SELECTABLE_TYPES: $AllSelectableTypes[] = [
  "text",
  "todo",
  "shopping",
  "link",
  "location",
];
